import React from 'react';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Text from '~/src/components/Typography/Text';
import getCustomRadius from '~/src/lib/getCustomRadius';
import getCustomButton1 from '~/src/lib/getCustomButton1';

export default function App(props) {
    if (props.loading) {
        return (
            <LoadingButton
                style={{
                    backgroundColor: getCustomButton1(props.business),
                    color: '#FFFFFF',
                    borderRadius: getCustomRadius(props.business),
                    padding: 10,
                    opacity: 0.6,
                    ...props.style,
                }}
                loading
                //loadingPosition="start"
                fullWidth={
                    typeof props.fullWidth === 'boolean'
                        ? props.fullWidth
                        : true
                }
                variant="contained"
            >
                &nbsp;
            </LoadingButton>
        );
    }

    if (props.disabled) {
        return (
            <Button
                style={{
                    borderRadius: getCustomRadius(props.business),
                    padding: 10,
                }}
                fullWidth={
                    typeof props.fullWidth === 'boolean'
                        ? props.fullWidth
                        : true
                }
                variant="contained"
                disabled
                startIcon={props.startIcon ? props.startIcon : false}
            >
                <Text noWrap={true} variant="button">
                    {props.children}
                </Text>
            </Button>
        );
    }

    return (
        <Button
            style={{
                backgroundColor: getCustomButton1(props.business),
                color: '#FFFFFF',
                borderRadius: getCustomRadius(props.business),
                padding: 10,

                ...props.style,
            }}
            startIcon={props.startIcon ? props.startIcon : false}
            fullWidth={
                typeof props.fullWidth === 'boolean' ? props.fullWidth : true
            }
            variant="contained"
            onClick={props.onClick}
        >
            <Text noWrap={true} variant="button">
                {props.children}
            </Text>
        </Button>
    );
}
